import React, { useEffect, useMemo, useState } from "react";
import {
  Breadcrumbs,
  Button,
  Modal,
  Select,
} from "../../../../../components/core";
import { ContentContainer } from "../../../../../components/layout";
import DropoffCostTable from "../partner-fees/dropoff-cost-table";
import { useDispatch, useSelector } from "react-redux";
import {
  ADD_PARTNER_DROPOFF_FEE,
  ADD_PARTNER_SHIPOUT_FEE,
  LOCKER_RELATED_PARTNER_TYPE_LIST,
  LOCKER_TYPES,
  PARTNER_DROPOFF_FEE,
  PARTNER_SHIPOUT_FEE,
  UPDATE_DROPOFF_FEE,
  UPDATE_PARTNER_SHIPOUT_FEE,
} from "../../../../../constants/graphql/locker-queries";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import PackageShipoutCostTable from "../partner-fees/package-shipout-cost-table";
import { useNavigate, useParams } from "react-router-dom";
import {
  handelCancelChagesReducer,
  handleAddDataItemReducer,
  handleEditAddedDataReducer,
  handleEditDataReducer,
  handleShipoutAddDataItemReducer,
  handleShipoutEditAddedDataReducer,
  handleShipoutEditDataReducer,
  setLockerTypeList,
  setPartnerDropoffFees,
  setPartnerShipoutFees,
  setPartnerTypeList,
} from "../../../../../features/locker-fees/edit-partner-fees-slice";
import { Strings } from "../../../../../constants/strings";
import useSidebarStore from "../../../../../zustand/stores/sidebar-store";
import { PARTNER_TYPE_FOR_PARTNER } from "../../../../../constants/graphql/partners-query";
import { LOCKER_TIME_LIMIT } from "../../../../../constants/graphql/locker-time-limits-query";
const breadcrumbItems = [
  {
    label: "Locker Fees",
    path: `/locker-fees/`,
  },
  { label: "Edit Partner Fee", path: "#" },
];
export default function EditPartnerFees() {
  const [changesMade, setChangesMade] = useState(false);
  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions
  );
  const operatorId = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user")).operator_id
    : "";
  const dispatch = useDispatch();
  const { lockerTypeId, partnerTypeId } = useParams();
  const navigate = useNavigate();
  // zustand
  const pendingNavigation = useSidebarStore((state) => state.pendingNavigation);
  const setPendingNavigation = useSidebarStore(
    (state) => state.setPendingNavigation
  );
  const activeSubItem = useSidebarStore((state) => state.activeSubItem);
  const setActiveSubItem = useSidebarStore((state) => state.setActiveSubItem);
  // Selectors
  const addDropoffCostItem = useSelector(
    (state) => state.editPartnerFee.addDataItem
  );
  const addPackageShipoutCostItem = useSelector(
    (state) => state.editPartnerFee.addShipoutData
  );
  const lockerTypesList = useSelector(
    (state) => state.editPartnerFee.lockerTypesList
  );
  //   const partnerTypesList = useSelector(
  //     (state) => state.editPartnerFee.partnerTypesList
  //   );
  const partnerDropoffFees = useSelector(
    (state) => state.editPartnerFee.partnerDropoffFees
  );
  const partnerShipoutFees = useSelector(
    (state) => state.editPartnerFee.partnerShipoutFees
  );
  const lockerTypeAndPartnerType = useSelector(
    (state) => state.addPartnerFee.lockerTypeAndPartnerType
  );

  //   const lockerTypeAndPartnerType = useSelector(
  //     (state) => state.addPartnerFee.lockerTypeAndPartnerType
  //   );
  //Graphql
  const lockerTypes = useQuery(LOCKER_TYPES, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
    },
  });
  const partnerTypes = useQuery(PARTNER_TYPE_FOR_PARTNER, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      partnerTypeId: partnerTypeId,
    },
  });
  const partnertDropoffFee = useQuery(PARTNER_DROPOFF_FEE, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      partnerTypeId: partnerTypeId,
      lockerTypeId: lockerTypeId,
    },
    fetchPolicy: "no-cache",
  });
  const partnerShipoutFee = useQuery(PARTNER_SHIPOUT_FEE, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      partnerTypeId: partnerTypeId,
      lockerTypeId: lockerTypeId,
    },
    fetchPolicy: "no-cache",
  });
  const [lockerTimeLimit, { data: lockerLimit, refetch }] = useLazyQuery(
    LOCKER_TIME_LIMIT,
    {
      fetchPolicy: "no-cache",
    }
  );
  const [addPartnerDropoffFee] = useMutation(ADD_PARTNER_DROPOFF_FEE);
  const [addPartnerShipoutFee] = useMutation(ADD_PARTNER_SHIPOUT_FEE);
  const [editPartnerDropoffFee] = useMutation(UPDATE_DROPOFF_FEE);
  const [editPartnerShipoutFee] = useMutation(UPDATE_PARTNER_SHIPOUT_FEE);
  // Local states
  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "Invalid data",
    message: "",
    open: false,
  });
  const [confirmValidation, setConfirmValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "Invalid data",
    message: "",
    open: false,
  });
  const [finalPartnerTypeList, setFinalPartnerTypeList] = useState([]);
  const [partnerTypeList, setPartnerTypeList] = useState([]);

  //   // ---- Handle Events ------/
  //   const handleOnChangeLockerTypeAndPartnerType = (event) => {
  //     const { name, value } = event.target;
  //     dispatch(
  //       handleChangeLockerTypeAndPartnerTypeReducer({ name: name, value: value })
  //     );
  //   };
  //   // For Dropoff Cost
  const handleAddDropoffCostItem = () => {
    dispatch(
      handleAddDataItemReducer({
        operatorId: localStorage.getItem("user")
          ? JSON.parse(localStorage.getItem("user")).operator_id
          : "",
        lockerTypeId: lockerTypeId,
        partnerTypeId: partnerTypeId,
        doorSizeId: "1",
        dropoffFee: "",
        initialFreeHours: "",
      })
    );
    setChangesMade(true);
  };
  const handleEditAddedDropoffCostItem = (event) => {
    const { name, value, id } = event.target;
    dispatch(
      handleEditAddedDataReducer({
        name: name,
        value: value,
        id: id,
      })
    );
    setChangesMade(true);
  };
  const handleEditDropoffCostItem = (event) => {
    const { name, value, id } = event.target;
    dispatch(
      handleEditDataReducer({
        name: name,
        value: value,
        id: id,
      })
    );
    setChangesMade(true);
  };
  // For Package Shipout Cost
  const handleAddPackageShipoutCostItem = () => {
    dispatch(
      handleShipoutAddDataItemReducer({
        operatorId: localStorage.getItem("user")
          ? JSON.parse(localStorage.getItem("user")).operator_id
          : "",
        lockerTypeId: lockerTypeId,
        partnerTypeId: partnerTypeId,
        doorSizeId: "1",
        commissionPercent: "",
        initialShipoutFee: "",
        initialFreeHours: "",
        excessFeePerInc: "",
        incByHours: "",
        maxOverstayCharge: "",
      })
    );
    setChangesMade(true);
  };
  const handleEditAddedPackageShipoutCostItem = (event) => {
    const { name, value, id } = event.target;
    dispatch(
      handleShipoutEditAddedDataReducer({
        name: name,
        value: value,
        id: id,
      })
    );
    setChangesMade(true);
  };
  const handleEditPackageShipoutCostItem = (event) => {
    const { name, value, id } = event.target;
    dispatch(
      handleShipoutEditDataReducer({
        name: name,
        value: value,
        id: id,
      })
    );
    setChangesMade(true);
  };

  useEffect(() => {
    // console.log("Effect triggered:", {
    // 	pendingNavigationHere,
    // 	changesMade,
    // 	currentPath: location.pathname,
    // });
    if (pendingNavigation !== null) {
      if (changesMade) {
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
          title: `${Strings.popup_confirm_cancel_title}?`,
          message: Strings.popup_confirm_cancel_massage,
          open: true,
          actions: (
            <div className="flex justify-between gap-3">
              <Button
                onClick={() => {
                  setValidation({ open: false });
                  // window.location.reload();
                  setPendingNavigation(null);
                  setActiveSubItem(activeSubItem);
                }}
                value={"No"}
                className={"p-2 w-full"}
              />
              <Button
                onClick={() => {
                  navigate(pendingNavigation);
                  setPendingNavigation(null);
                }}
                value={"Yes"}
                className={"p-2 w-full"}
              />
            </div>
          ),
        });
      } else {
        navigate(pendingNavigation);
        setPendingNavigation(null);
      }
    }
  }, [pendingNavigation, changesMade]);

  //   // To Save Changes
  const handleSaveChanges = () => {
    if (lockerTypeId === "-1" || partnerTypeId === "-1") {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Incomplete Search Criteria",
        message: "Please select Locker Type  & Partner Type.",
        open: true,
        actions: (
          <div className="grid grid-cols-1 gap-2">
            <Button
              onClick={() => {
                setValidation((prev) => ({
                  ...prev,
                  open: false,
                }));
              }}
              value={"OK"}
              className={"p-2"}
            />
          </div>
        ),
      });
    } else {
      let flag = true;
      let emptyDropoffcostArray = [
        ...partnerDropoffFees,
        ...addDropoffCostItem,
      ].filter(
        (x) =>
          x.doorSizeId === "" ||
          x.dropoffFee === "" ||
          x.initialFreeHours === ""
      );
      let emptyShipoutCostArray = [
        ...partnerShipoutFees,
        ...addPackageShipoutCostItem,
      ].filter(
        (x) =>
          x.doorSizeId === "" ||
          x.commissionPercent === "" ||
          x.initialShipoutFee === "" ||
          x.initialFreeHours === "" ||
          x.excessFeePerInc === "" ||
          x.incByHours === "" ||
          x.maxOverstayCharge === ""
      );
      let duplicateDoorSizeIdArrayDropoff = [
        ...partnerDropoffFees,
        ...addDropoffCostItem,
      ].filter((item, index, self) => {
        return (
          self.findIndex((t) => t.doorSizeId === item.doorSizeId) !== index
        );
      });
      let duplicateDoorSizeIdArray = [
        ...partnerShipoutFees,
        ...addPackageShipoutCostItem,
      ].filter((item, index, self) => {
        return (
          self.findIndex((t) => t.doorSizeId === item.doorSizeId) !== index
        );
      });
      if (
        emptyDropoffcostArray.length > 0 ||
        emptyShipoutCostArray.length > 0
      ) {
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
          title: "Form Error",
          message: "All fields are required.",
          open: true,
          actions: (
            <div className="grid grid-cols-1 gap-2">
              <Button
                onClick={() => {
                  setValidation((prev) => ({
                    ...prev,
                    open: false,
                  }));
                }}
                value={"OK"}
                className={"p-2"}
              />
            </div>
          ),
        });
      } else if (
        duplicateDoorSizeIdArray.length > 0 ||
        duplicateDoorSizeIdArrayDropoff.length > 0
      ) {
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
          title: Strings.popup_error_title_duplicate,
          message: "There is duplicate door size in your entry.",
          open: true,
          actions: (
            <div className="grid grid-cols-1 gap-2">
              <Button
                onClick={() => {
                  setValidation((prev) => ({
                    ...prev,
                    open: false,
                  }));
                }}
                value={"OK"}
                className={"p-2"}
              />
            </div>
          ),
        });
      } else {
        // Add Part
        addDropoffCostItem.forEach((element) => {
          addPartnerDropoffFee({ variables: element })
            .then((data) => {})
            .catch((e) => {
              setValidation({
                icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                title: Strings.popup_error_title_duplicate,
                message: e.message,
                open: true,
                actions: (
                  <div className="grid grid-cols-1 gap-2">
                    <Button
                      onClick={() => {
                        setValidation((prev) => ({
                          ...prev,
                          open: false,
                        }));
                      }}
                      value={"OK"}
                      className={"p-2"}
                    />
                  </div>
                ),
              });
              flag = false;
            });
        });
        addPackageShipoutCostItem.forEach((element) => {
          let tempElement = { ...element };
          tempElement.commissionPercent = element.commissionPercent / 100;
          addPartnerShipoutFee({ variables: tempElement })
            .then(() => {})
            .catch((e) => {
              setValidation({
                icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                title: Strings.popup_error_title_duplicate,
                message: e.message,
                open: true,
                actions: (
                  <div className="grid grid-cols-1 gap-2">
                    <Button
                      onClick={() => {
                        setValidation((prev) => ({
                          ...prev,
                          open: false,
                        }));
                      }}
                      value={"OK"}
                      className={"p-2"}
                    />
                  </div>
                ),
              });
              flag = false;
            });
        });

        // Edit Part
        let tempPartnerDropoffFees = [...partnerDropoffFees];
        tempPartnerDropoffFees = tempPartnerDropoffFees.map((obj) => ({
          ...obj,
          operatorId: localStorage.getItem("user")
            ? JSON.parse(localStorage.getItem("user")).operator_id
            : "",
          lockerTypeId: lockerTypeId,
          partnerTypeId: partnerTypeId,
        }));
        let tempPartnerShipoutFees = [...partnerShipoutFees];
        tempPartnerShipoutFees = tempPartnerShipoutFees.map((obj) => ({
          ...obj,
          operatorId: localStorage.getItem("user")
            ? JSON.parse(localStorage.getItem("user")).operator_id
            : "",
          lockerTypeId: lockerTypeId,
          partnerTypeId: partnerTypeId,
          commissionPercent: parseFloat(obj.commissionPercent / 100),
        }));
        editPartnerShipoutFee({
          variables: {
            partnerShipoutFees: tempPartnerShipoutFees,
          },
        })
          .then((data) => {})
          .catch((e) => {});
        editPartnerDropoffFee({
          variables: { partnerDropoffFees: tempPartnerDropoffFees },
        })
          .then((data) => {})
          .catch((e) => {});
        // handleCancelChanges();
        // navigate("/locker-fees/");
        setTimeout(() => {
          window.location.reload(); // Reload after a brief delay
        }, 200);
      }
    }
  };
  const handleCancelChanges = () => {
    navigate("/locker-fees/");
    dispatch(handelCancelChagesReducer());
  };
  //   // Use Effects
  React.useEffect(() => {
    if (partnerTypes.data) {
      let tempVar = [];

      partnerTypes.data.partnerTypes.forEach((element) => {
        tempVar.push({
          value: element.partnerTypeId,
          name: element.partnerType,
          pickupPulloutLimit:
            element.lockerPartnerLimits.length > 0
              ? element.lockerPartnerLimits[0].pickupPulloutLimit
              : null,
        });
      });
      //   dispatch(setPartnerTypeList(tempVar));
      setPartnerTypeList(tempVar);
    }
  }, [partnerTypes.data]);
  React.useEffect(() => {
    if (lockerTypes.data) {
      let tempVar = [];
      lockerTypes.data.lockerTypes.forEach((element) => {
        tempVar.push({
          value: element.lockerTypeId,
          name: element.lockerType,
        });
      });

      dispatch(setLockerTypeList(tempVar));
    }
  }, [lockerTypes.data]);
  React.useEffect(() => {
    if (partnertDropoffFee.data) {
      let tempVar = [];
      partnertDropoffFee.data.partnerDropoffFees.forEach((element) => {
        tempVar.push({
          partnerDropoffFeeId: element.partnerDropoffFeeId,
          doorSizeId: element.doorSize.doorSizeId,
          dropoffFee: element.dropoffFee,
          initialFreeHours: element.initialFreeHours,
          rtsFee: element.rtsFee,
          rtsOverstayRate: element.rtsOverstayRate,
          rtsOverstayMaxFee: element.rtsOverstayMaxFee,
          rtsOverstayUnitHours: element.rtsOverstayUnitHours,
        });
      });
      dispatch(setPartnerDropoffFees(tempVar));
    }
  }, [partnertDropoffFee.data]);
  React.useEffect(() => {
    if (partnerShipoutFee.data) {
      let tempVar = [];
      partnerShipoutFee.data.partnerShipoutFees.forEach((element) => {
        tempVar.push({
          partnerShipoutFeeId: element.partnerShipoutFeeId,
          doorSizeId: element.doorSize.doorSizeId,
          commissionPercent: element.commissionPercent * 100,
          initialShipoutFee: element.initialShipoutFee,
          initialFreeHours: element.initialFreeHours,
          incByHours: element.incByHours,
          excessFeePerInc: element.excessFeePerInc,
          maxOverstayCharge: element.maxOverstayCharge,
        });
      });
      dispatch(setPartnerShipoutFees(tempVar));
    }
  }, [partnerShipoutFee.data]);

  useEffect(() => {
    if (partnerTypeList && partnerTypeList.partnerTypes?.length > 0) {
      const map = partnerTypeList.partnerTypes
        .filter(
          (category) =>
            !(
              category.partnerDropoffFees?.length > 0 ||
              category.partnerShipoutFees?.length > 0
            )
        )
        .map((category) => ({
          value: category.partnerTypeId,
          name: category.partnerType,
          pickupPulloutLimit:
            category.lockerPartnerLimits.length > 0
              ? category.lockerPartnerLimits.pickupPulloutLimit
              : null,
        }));

      setFinalPartnerTypeList(map);
    }
  }, [partnerTypeList.partnerTypes]);

  const [partnerTypeLimits, setPartnerTypeLimits] = useState(null);

  useEffect(() => {
    if (partnerTypeId) {
      lockerTimeLimit({
        variables: {
          operatorId: operatorId,
          lockerTypeId: lockerTypeId,
          partnerTypeId: partnerTypeId,
        },
      });
    }
  }, [partnerTypeId, operatorId, lockerTypeId]);

  useEffect(() => {
    if (lockerLimit && lockerLimit?.lockerPartnerLimits.length > 0) {
      setPartnerTypeLimits(lockerLimit?.lockerPartnerLimits[0]);
    }
  }, [lockerLimit]);

  console.log({ partnerTypeLimits, lockerLimit });
  return (
    <div>
      <Breadcrumbs items={breadcrumbItems} />
      <ContentContainer containerTitle={"Locker Fees"}>
        <div className="left w-1/2 grid grid-cols-2 gap-x-2 gap-y-6 pr-2">
          <p className="my-auto">Locker Type:</p>
          <p className="font-bold">
            {lockerTypesList.find((x) => x.value === lockerTypeId) &&
              lockerTypesList.find((x) => x.value === lockerTypeId).name}
          </p>
          {/* <Select
            items={lockerTypesList}
            value={lockerTypeAndPartnerType.lockerTypeId}
            name="lockerTypeId"
            onChange={handleOnChangeLockerTypeAndPartnerType}
            defaultOption={{ value: "-1", name: "-- Select Locker Type --" }}
          /> */}
          <p className="my-auto">Partner Type:</p>
          <p className="font-bold">
            {partnerTypeList.find((x) => x.value === partnerTypeId) &&
              partnerTypeList.find((x) => x.value === partnerTypeId).name}
          </p>
        </div>
        {/* Here is the tables */}
        <DropoffCostTable
          pulloutHours={
            partnerTypeLimits?.pickupPulloutLimit !== null
              ? partnerTypeLimits?.pickupPulloutLimit
              : 0
          }
          disabled={
            accessPermission.lockerFees === 1 ||
            accessPermission.lockerFees === "1"
          }
          items={partnerDropoffFees}
          lockerType={
            lockerTypesList.find((x) => x.value === lockerTypeId)
              ? lockerTypesList.find((x) => x.value === lockerTypeId).name
              : ""
          }
          partnerType={
            partnerTypeList.find((x) => x.value === partnerTypeId)
              ? partnerTypeList.find((x) => x.value === partnerTypeId).name
              : ""
          }
          handleAddDataItem={handleAddDropoffCostItem}
          handleModifyAddedItems={handleEditAddedDropoffCostItem}
          handleModifyDataItems={handleEditDropoffCostItem}
          addedData={addDropoffCostItem}
        />
        <PackageShipoutCostTable
          disabled={
            accessPermission.lockerFees === 1 ||
            accessPermission.lockerFees === "1"
          }
          items={partnerShipoutFees}
          lockerType={
            lockerTypesList.find((x) => x.value === lockerTypeId)
              ? lockerTypesList.find((x) => x.value === lockerTypeId).name
              : ""
          }
          partnerType={
            partnerTypeList.find((x) => x.value === partnerTypeId)
              ? partnerTypeList.find((x) => x.value === partnerTypeId).name
              : ""
          }
          addedData={addPackageShipoutCostItem}
          handleAddDataItem={handleAddPackageShipoutCostItem}
          handleModifyAddedItems={handleEditAddedPackageShipoutCostItem}
          handleModifyDataItems={handleEditPackageShipoutCostItem}
        />
        {changesMade && (
          <div className="grid grid-cols-2 gap-2 w-1/4">
            <Button
              value={"Cancel Changes"}
              disabled={
                accessPermission.lockerFees === 1 ||
                accessPermission.lockerFees === "1"
              }
              className={"p-2"}
              onClick={() => {
                setConfirmValidation({
                  icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                  title: "Cancel Changes",
                  message: "Are you sure you want to cancel changes?",
                  open: true,
                  event: handleCancelChanges,
                });
              }}
            />
            <Button
              value={"Save Changes"}
              disabled={
                accessPermission.lockerFees === 1 ||
                accessPermission.lockerFees === "1"
              }
              className={"p-2"}
              onClick={() => {
                setConfirmValidation({
                  icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
                  title: "Save Changes",
                  message: "Are you sure you want to save changes?",
                  open: true,
                  event: handleSaveChanges,
                });
              }}
            />
          </div>
        )}
        <Modal
          icon={validation.icon}
          title={validation.title}
          message={validation.message}
          open={validation.open}
          actions={
            validation.actions
            // <div className="grid grid-cols-1 gap-2">
            // 	<Button
            // 		onClick={() => {
            // 			setValidation((prev) => ({
            // 				...prev,
            // 				open: false,
            // 			}));
            // 		}}
            // 		value={"OK"}
            // 		className={"p-2"}
            // 	/>
            // </div>
          }
        />
        <Modal
          icon={confirmValidation.icon}
          title={confirmValidation.title}
          message={confirmValidation.message}
          open={confirmValidation.open}
          actions={
            <div className="grid grid-cols-2 gap-2">
              <Button
                onClick={() => {
                  setConfirmValidation((prev) => ({
                    ...prev,
                    open: false,
                  }));
                }}
                value={"No"}
                className={"p-2"}
              />
              <Button
                onClick={() => {
                  setConfirmValidation((prev) => ({
                    ...prev,
                    open: false,
                  }));
                  confirmValidation.event();
                }}
                value={"Yes"}
                className={"p-2"}
              />
            </div>
          }
        />
      </ContentContainer>
    </div>
  );
}
